<ngx-dropzone (change)="onSelect($event)"
              [multiple]="false">
  <ngx-dropzone-label>Drop document!</ngx-dropzone-label>
  <ngx-dropzone-preview *ngFor="let f of files"
                        [removable]="true"
                        (removed)="onRemove(f)">
    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
  </ngx-dropzone-preview>
</ngx-dropzone>